import { Grid } from '@material-ui/core';
import { Link } from 'gatsby';
import { styled } from 'linaria/react';
import React from 'react';
import { routes } from '../../../lib/routes';
import { Borders } from '../Borders/Borders';
import { ContainerCustom } from '../ConatinerCustom/ContainerCustom';
import { HeadingWithNote } from '../HedingWithNote/HeadingWithNote';
import { KVButton } from '../KVButton/KVButton';
import { Section } from '../Section/Section';
import { HeadingThree } from '../Typography/HeadingThree/HeadingThree';
import { TrainingPlace } from './components/TrainingPlace/TrainingPlace';
import { useTrainingPlaces } from './hooks/useTrainingPlaces';

export interface TrainingPlacesProps {
  className?: string;
  borderRight?: boolean;
}

const TrainingPlacesInner = (props: TrainingPlacesProps) => {
  const places = useTrainingPlaces();
  return (
    <Section className={props.className}>
      <ContainerCustom>
        <Borders {...(props.borderRight
          ? { topRight: true, bottomRight: true }
          : { topLeft: true, bottomLeft: true }
        )} >
          <div className="places">
            <HeadingWithNote
              heading={'TRÉNINGOVÉ MIESTA'}
              note="Pri individuálnych tréningoch rešpektujeme klienta, preto čas a miesto 
              je na základe vzájomnej dohody."
            />
            <Grid container spacing={4}>
              {places.map(place => (
                <Grid key={place.name} item xs={12} md={4}>
                  <TrainingPlace {...place} />
                </Grid>
              ))}
            </Grid>
          </div>
        </Borders>
      </ContainerCustom>
    </Section>
  );
};

export const TrainingPlaces = styled(TrainingPlacesInner)`
  .places {
    padding: 40px;
  }
`;
